import { Location } from 'history';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getRouterState } from '../../../global/selectors';
import { LocationState } from '../../../global/types';
import { defaultSortOrder } from '../constants';
import { ModerationListSortOrder } from '../types';

type ModerationListQueryParams = {
  location: Location<LocationState>;
  locationState: LocationState;
  search: string;
  sortOrder: ModerationListSortOrder;
  start: number;
};

const parseModerationListSortOrder = (sort: string): ModerationListSortOrder => {
  const sortModerationList = Object.values(ModerationListSortOrder);
  return sortModerationList.includes(sort as ModerationListSortOrder)
    ? (sort as ModerationListSortOrder)
    : defaultSortOrder;
};

const useModerationListQueryParams = (): ModerationListQueryParams => {
  const { location } = useSelector(getRouterState);
  const parsed = queryString.parse(location.search);
  const start: number = parsed.start ? parseInt(parsed.start.toString(), 10) : 0;
  const search: string = parsed.search ? parsed.search.toString() : '';
  const sortOrder = parseModerationListSortOrder(parsed.sort ? parsed.sort.toString() : '');
  const { state } = location;

  return {
    location,
    locationState: state,
    search,
    sortOrder,
    start,
  };
};

export default useModerationListQueryParams;
